import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const RestoreMeetingPrepLearnedDefaultMutation = graphql(`
  mutation RestoreMeetingPrepLearnedDefault($id: ID!) {
    restoreMeetingPrepLearnedDefault(id: $id) {
      id
      __typename
      cardKey
      suppressedAt
      learnedAfterHides
    }
  }
`);

export function useRestoreMeetingPrepLearnedDefault() {
  const [result, restoreMeetingPrepLearnedDefaultMutation] = useMutation(RestoreMeetingPrepLearnedDefaultMutation);
  const [error, setError] = useState<Error | null>(null);

  const restoreMeetingPrepLearnedDefault = useCallback(
    async (id: string) => {
      try {
        const response = await restoreMeetingPrepLearnedDefaultMutation({ id });
        if (response.error) {
          throw response.error;
        }
        setError(null);
        return response.data?.restoreMeetingPrepLearnedDefault;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [restoreMeetingPrepLearnedDefaultMutation],
  );

  return { restoreMeetingPrepLearnedDefault, result, error };
}
